import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { loginMentor } from "../../../actions/auth";
import { setAlert } from "../../../actions/alert";

import Alert from "../IME/Alert";
import RedLogo from "./RedLogo";
import IMEAltLogo from "../IME/IMEAltLogo";

const MentorLogin = ({ loginMentor, isAuthenticated, setAlert }) => {
  const [profileDropDown, setprofileDropDown] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const { email, password } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      setAlert("Please enter a valid email");
    }
    if (password === "") {
      setAlert("Please enter a password");
    }
    loginMentor(email, password);
  };

  let passwordLength = password.split("");

  return (
    <Fragment>
      <nav className="login-nav background-dark-black border-bottom grey">
        <form
          className="main"
          action="/:channelid"
          method="POST"
          onSubmit={(e) => onSubmit(e)}
        >
          <div className="action-items-index">
            <Link to="/">
              <div className="action-button-index red">
                <i className="fas fa-angle-left action-icon-index-alt fa-lg red"></i>
              </div>
            </Link>
            <p className="action-text-index red">Back</p>
          </div>
          <div className="action-items-index">
            <div
              className="action-button-index red"
              onClick={() => {
                if (!profileDropDown) {
                  setprofileDropDown(true);
                } else {
                  setprofileDropDown(false);
                }
              }}
            >
              <i className="fas fa-user action-icon-index fa-lg red"></i>
            </div>
            <p className="action-text-index red">Login</p>
          </div>
          {profileDropDown && (
            <div className="profile-drop-down-alternate">
              <div className="profile-drop-container-nav">
                <div className="label-input">
                  <label htmlFor="email" className="labels red">
                    *Email:
                  </label>
                  {email === "" && <Alert />}
                  <input
                    name="email"
                    className="input-style-nav"
                    type="email"
                    value={email}
                    placeholder="Enter Email Address"
                    onChange={(e) => onChange(e)}
                    tabIndex="2"
                  />
                </div>
                <div className="label-input">
                  <label htmlFor="password" className="labels red">
                    *Password:
                  </label>
                  {password === "" && <Alert />}
                  <input
                    name="password"
                    className="input-style-nav"
                    type="password"
                    min={7}
                    maxLength={20}
                    value={password}
                    placeholder="Enter Password"
                    onChange={(e) => onChange(e)}
                    tabIndex="2"
                  />
                  {email !== "" &&
                    password !== "" &&
                    passwordLength.length >= 7 &&
                    passwordLength.length <= 20 && (
                      <div className="login-button-container-alt">
                        <button
                          className="login-button-alt background-red"
                          type="submit"
                        >
                          Login
                        </button>
                      </div>
                    )}
                  {/* <Link to="/forgotpassword">
                    <p className="forgot red" tabIndex="4">
                      Forgot Password?
                    </p>
                  </Link> */}
                </div>
              </div>
            </div>
          )}
        </form>
        <div className="center-nav">
          <div className="index-logo-alt">
            <RedLogo />
          </div>
          <i className="fas fa-trademark red fa-sm mt-10"></i>
          <div className="index-logo">
            <IMEAltLogo />
          </div>
        </div>
      </nav>
    </Fragment>
  );
};

MentorLogin.propTypes = (state) => ({
  loginMentor: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
});

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  redirected: state.auth.redirected,
});

export default connect(mapStateToProps, { loginMentor, setAlert })(MentorLogin);
